<template>
  <div style="width: 100%; height: 100%">
    <div class="lineBar"
         style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

const colors = ['#5470C6', '#91CC75', '#EE6666']
export default {
  props: {
    chartData: {
      type: Object,
      default: () => { }
    },
    isFLK: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chart: {}
    }
  },
  created () { },
  mounted () {
    this.chart = echarts.init(document.querySelector('.lineBar'))
    // 根据浏览器宽度变化改变可视化报表图宽高
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
    this.updateCharts()
  },
  methods: {
    updateCharts () {
      // const { monthTotal, inQuantity, outQuantity, xAxisData, endingQuantityTotal, inQuantityTotal, outQuantityTotal, openingQuantityTotal } = this.chartData
      const { monthTotal, inQuantity, outQuantity, xAxisData } = this.chartData
      // const totalIn = inQuantity.reduce((pre, cur) => pre + cur, 0)
      // const totalOut = outQuantity.reduce((pre, cur) => pre + cur, 0)
      // const totalQuantity = monthTotal.reduce((pre, cur) => pre + cur, 0)
      this.chart.setOption && this.chart.setOption({
        title: {
          // text: this.isFLK ? `${openingQuantityTotal ? `期初库存${openingQuantityTotal.toFixed(2)}吨  ` : ''}入库量${(inQuantityTotal || totalIn).toFixed(2)}吨   出库量${(outQuantityTotal || totalOut).toFixed(2)}吨` : `${openingQuantityTotal ? `期初库存${openingQuantityTotal.toFixed(2)}吨  ` : ''}入库量${(inQuantityTotal || totalIn).toFixed(2)}吨   出库量${(outQuantityTotal || totalOut).toFixed(2)}吨  总库存${(endingQuantityTotal || totalQuantity).toFixed(2)}吨`,
          text: '当月每日出入库及库存量',
          left: 'center',
          top: '1px',
          textStyle: {
            color: '#c3cbde',
            fontSize: '18px',
            fontWeight: 'bold'
          }
        },
        color: colors,
        // tooltip: {
        //   trigger: 'axis',
        //   axisPointer: {
        //     type: 'cross',
        //     crossStyle: {
        //       color: '#999'
        //     }
        //   }
        // },
        grid: {
          right: '14%',
          top: '20%',
          bottom: '8%'
        },
        legend: {
          top: '10%',
          textStyle: {
            color: '#fff'
          },
          data: ['库存', '入库', '出库']
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            // prettier-ignore
            data: xAxisData,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: '#fff'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '库存',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0]
              }
            },
            axisLabel: {
              formatter: '{value}',
              color: '#fff'
            },
            nameTextStyle: {
              color: '#fff'
            }
          },
          {
            type: 'value',
            name: '入库',
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1]
              }
            },
            axisLabel: {
              formatter: '{value}',
              color: '#fff'
            },
            nameTextStyle: {
              color: '#fff'
            },
            min: 0
          },
          {
            type: 'value',
            name: '出库',
            offset: 50,
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[2]
              }
            },
            axisLabel: {
              formatter: '{value}',
              color: '#fff'
            },
            nameTextStyle: {
              color: '#fff'
            },
            max: 0
          }
        ],
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            if (this.isFLK) {
              params = params.filter(item => item.seriesName !== '库存')
            }
            let result = params[0].name + '<br/>'
            params.forEach(item => {
              result += `${item.marker} ${item.seriesName}: ${item.value}t<br/>`
            })
            return result
          }
        },
        series: [
          {
            name: '库存',
            type: 'line',
            connectNulls: false,
            step: 'end',
            // tooltip: {
            //   valueFormatter: function (value) {
            //     return value + 't'
            //   }
            // },
            data: monthTotal
          },
          {
            name: '入库',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            // tooltip: {
            //   valueFormatter: function (value) {
            //     return value + 't'
            //   }
            // },
            yAxisIndex: 1,
            data: inQuantity
          },
          {
            name: '出库',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            // tooltip: {
            //   valueFormatter: function (value) {
            //     return value + 't'
            //   }
            // },
            yAxisIndex: 2,
            data: outQuantity
          }
        ]
      })
    }
  }
  // watch: {
  //   chartData: {
  //     handler (val) {
  //       this.updateCharts()
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style scoped lang="scss"></style>
